/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import styles from "../styles/Sidebar.module.css";
import "../styles/modal.css"
import { GiHamburgerMenu } from "react-icons/gi";
import {Help} from "./Help";
import AppUpdate from "./AppUpdate";
import { accountHandle } from "../../Account/state/actions";
import { useDispatch } from "react-redux";

function SideBar({ toggle, collapsed }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedKey, setSelectedKey] = useState("0");
  const location = useLocation();

  const highlightStyle = {
    backgroundColor : "#7dbdf8",
    borderBottom : "2px solid #1890ff"
  }
  
  const bos = (localStorage.getItem("screenType") === "BOS")
  const today = new Date();
  const [tabName,setTabName] = useState(location.pathname);

  const isBosRoute = location.pathname?.includes("/pendings") ||
  location.pathname?.includes("/listings") || 
  location.pathname === "/sales";
  const isHome = location.pathname === "/" ||
  location.pathname === "/metrics" ||
  location.pathname === "/support" || isBosRoute
  ;
  useEffect(() => {
    if (isHome) {
      setSelectedKey("0");
    } else if (location.pathname.startsWith("/contacts")) {
      setSelectedKey("1");
    } else if (location.pathname.startsWith("/calendar")) {
      setSelectedKey("2");
    } else if (location.pathname.startsWith("/offer")) {
      setSelectedKey("3");
    } else if (location.pathname.startsWith("/transactions")) {
      setSelectedKey("4");
    } else if (location.pathname.startsWith("/tools")) {
      setSelectedKey("5");
    } else if (location.pathname.startsWith("/account")) {
      setSelectedKey("7");
    } else if (location.pathname.startsWith("/pricing")) {
      setSelectedKey("8");
    } else if (location.pathname.startsWith("/success")) {
      setSelectedKey("9");
    } else if (location.pathname.startsWith("/failed")) {
      setSelectedKey("10");
    }
  }, [location.pathname]);

  const getTabName = () => {
    if(location.pathname.includes("transactions")){
      if(location.pathname.includes("dashboard")){
        setTabName("RTD")
      }else{
        setTabName("TRANSACTIONS");
      }
    }else if(location.pathname.includes("tools")){
      if(location.pathname.includes("docsClause")){
        setTabName("DOCS_CLAUSE")
      }else if(location.pathname.includes("email_drip_campaign")){
        setTabName("EMAIL_DRIP_CAMPAIGN")
      }else if(location.pathname.includes("email_template")){
        setTabName("EMAIL_TEMPLATE")
      }else if(location.pathname.includes("safe-T-drive")){
        setTabName("SAFE_T_DRIVE")
      }else{
        setTabName("TOOLS")
      }
    }else if(location.pathname.includes("calendar")){
      setTabName("CALENDAR")
    }else if(location.pathname.includes("contact")){
      setTabName("CLIENT")
    }else{
      setTabName("HOME")
    }
  }

  useEffect(() => {
    getTabName()
  },[location])

  const handleAgentClick = (data) => {
    dispatch(accountHandle.handleCheckAllAgents());
  }

  return (
    <div
      style={{
        position: "sticky",
        zIndex: 5,
        width: "100%",
        top: "50px",
        background: "#fff",
        boxShadow: "rgba(100, 100, 100, 0.35) 0px 5px 8px",
      }}
    >
      {isBosRoute && <div
        style={{
          padding: "10px 20px",
          position: "absolute",
          color: "gray",
          cursor: "pointer",
          fontSize: "18px"
        }}
        onClick={() => {
            history.push(`/`);
        }}
      >
        <span
          style={{
              marginRight: "10px",
              fontSize: "18px",
          }}
        >
          <ArrowLeftOutlined />
        </span>
        Back
      </div>}
      <Menu
        mode="horizontal"
        defaultSelectedKeys={["0"]}
        // className="navbarMenu"
        selectedKeys={[selectedKey]}
        overflowedIndicator={
          <span>
            <GiHamburgerMenu size={28} style={{ marginTop: "10px" }}/>
          </span>
        }
        className={styles.mainSec}
        size="large"
      >
        <Menu.Item
          key="0"
          style={(isHome ?  highlightStyle : {})}
          className={styles.tabWidth}
        >
          <div className={styles.mainDiv} >
            <div className={styles.subDivMain}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                viewBox="0 0 29.103 29.547"
              >
                <g
                  xmlns="http://www.w3.org/2000/svg"
                  id="Page-1"
                  transform="translate(0 -0.5)"
                >
                  <g id="Core" transform="translate(0 0.5)">
                    <g id="home" transform="translate(0 0)">
                      <path
                        id="Shape"
                        d="M11.3,24.005V15.533h5.648v8.472h7.06v-11.3h4.236L14.121,0,0,12.709H4.236v11.3Z"
                        fill={
                          isHome
                            ? "#123A79"
                            : "#8C8C8C"
                        }
                        fillRule="evenodd"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div>
              <Link to="/">
                <span className={styles.fontTabMain} style={{ color: isHome ? "#123A79" : "#8C8C8C" }}>
                  { bos ? "Dashboard" : "Home"}
                </span>
              </Link>
            </div>
          </div>
        </Menu.Item>

        <Menu.Item
          key="4"
          style={(location.pathname.startsWith("/transactions") ?  highlightStyle : {})}
          className={styles.tabWidth}
        >
          <div className={styles.mainDiv}>
            <div className={styles.subDivMain} >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="30"
                viewBox="0 0 39.103 41.547"
              >
                <g
                  id="home-property-svgrepo-com_1_"
                  data-name="home-property-svgrepo-com (1)"
                  transform="translate(0 -23.275)"
                >
                  <g
                    id="Group_543"
                    data-name="Group 543"
                    transform="translate(0 23.275)"
                  >
                    <g
                      id="Group_542"
                      data-name="Group 542"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Path_691"
                        data-name="Path 691"
                        d="M37.325,55.268H35.548V37.581l.808.526a1.777,1.777,0,1,0,1.939-2.98L20.521,23.563a1.777,1.777,0,0,0-1.939,0L4.34,32.829h0l-3.53,2.3a1.777,1.777,0,0,0,1.939,2.98l.808-.526V55.268H1.778a1.777,1.777,0,0,0,0,3.555H37.325a1.777,1.777,0,0,0,0-3.555Zm-5.332,0H7.11v-20l12.442-8.095,12.442,8.095Z"
                        transform="translate(0 -23.275)"
                        fill={
                          location.pathname.startsWith("/transactions")
                            ? "#123A79"
                            : "#8C8C8C"
                        }
                      />
                    </g>
                  </g>
                  <g
                    id="Group_545"
                    data-name="Group 545"
                    transform="translate(12.229 35.878)"
                  >
                    <g id="Group_544" data-name="Group 544">
                      <path
                        id="Path_692"
                        data-name="Path 692"
                        d="M174.771,191.747a1.777,1.777,0,0,0-.52-1.257l-1.676-1.675a1.777,1.777,0,1,0-2.514,2.514l.419.419-2.727,2.727a5.326,5.326,0,1,0,2.514,2.514L174.25,193A1.778,1.778,0,0,0,174.771,191.747Zm-8.061,8.8a1.777,1.777,0,1,1,.521-1.257A1.765,1.765,0,0,1,166.709,200.544Z"
                        transform="translate(-160.123 -188.294)"
                        fill={
                          location.pathname.startsWith("/transactions")
                            ? "#123A79"
                            : "#8C8C8C"
                        }
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
            <div>
              <Link to="/transactions">
                <span className={styles.fontTabMain} style={{ color: location.pathname.startsWith("/transactions") ? "#123A79" : "#8C8C8C" }}>
                  Transactions
                </span>
              </Link>
            </div>
          </div>
        </Menu.Item>

        <Menu.Item
          key="1"
          style={(location.pathname.startsWith("/contacts") ?  highlightStyle : {})}
          className={styles.tabWidth}
        >
          <div className={styles.mainDiv}>
            <div className={styles.subDivMain} style={{marginBottom:"8px"}}>
              {localStorage.getItem("screenType") !== "BOS" ? <svg xmlns="http://www.w3.org/2000/svg" width="39" height="40" viewBox="0 0 51.537 29.747">
                <g
                  id="Group_644"
                  data-name="Group 644"
                  transform="translate(-6353.336 -1457.634)"
                >
                  <g
                    id="_473798_agreement_business_contract_deal_greeting_icon"
                    data-name="473798_agreement_business_contract_deal_greeting_icon"
                    transform="translate(6353.336 1457.634)"
                  >
                    <path
                      id="Path_631"
                      data-name="Path 631"
                      d="M63.714,66.858l-4.762-9.549a.993.993,0,0,0-.216-.286.9.9,0,0,0-.3-.18l-5.584-2.007a3.543,3.543,0,0,0-2.474.024l-4.237,1.616a9.043,9.043,0,0,0-.886.394c-.1.05-.193.105-.289.159a7.868,7.868,0,0,0-1-.456,7.668,7.668,0,0,0-3.351-.462l-2.851.245a.87.87,0,0,0-.366.118.938.938,0,0,0-.29.269l-6.419,9.137a1.026,1.026,0,0,0-.181.679,1.007,1.007,0,0,0,.29.633l2.792,2.767a2.266,2.266,0,0,0,1.844,3.346c.032,0,.065,0,.1,0a2.262,2.262,0,0,0,2.012,2.94,2.267,2.267,0,0,0,2.1,3.125,2.248,2.248,0,0,0,1.6-.666,2.273,2.273,0,0,0,2.094,1.919c.05,0,.1.006.15.006a2.247,2.247,0,0,0,.787-.144,2.326,2.326,0,0,0,1.391.395,2.377,2.377,0,0,0,1.609-.735L45.74,78.618c0-.035.01-.069.012-.106a2.264,2.264,0,0,0-.111-.863l3.143,3.135a3.049,3.049,0,0,0,1.277.224,3.162,3.162,0,0,0,2.268-1.119l.315-.365a.506.506,0,0,0,.071-.115l-4.838-4.825a.343.343,0,0,1-.024-.458.288.288,0,0,1,.427-.009l5.754,5.738a2.673,2.673,0,0,0,1,.149,2.78,2.78,0,0,0,1.995-.985l.76-.879a1.13,1.13,0,0,0,.268-.774L53,72.331a.344.344,0,0,1-.024-.458.288.288,0,0,1,.427-.01l5.073,5.059a2.183,2.183,0,0,0,.652.074,2.272,2.272,0,0,0,1.633-.806l.2-.236a2.658,2.658,0,0,0-.124-3.565l-1.354-1.35.342.341L63.5,68.072a.992.992,0,0,0,.31-.566A1.045,1.045,0,0,0,63.714,66.858ZM35.5,72.327a1.289,1.289,0,0,1,.083-2.575l.086,0a1.289,1.289,0,1,1-.169,2.572Zm2.2,2.949a1.289,1.289,0,0,1-.95-2.16l.769-.811.127-.135a1.289,1.289,0,1,1,1.873,1.771l-.359.379-.243.257-.041.044-.161.169-.074.079-.012.013A1.276,1.276,0,0,1,37.692,75.275ZM40.569,78a1.288,1.288,0,0,1-1.814.041,1.292,1.292,0,0,1-.066-1.805l.641-.678h0l.249-.262c.435-.461.578-.61.626-.663l.017-.017h0l.067-.071a1.289,1.289,0,1,1,1.871,1.773ZM43.4,79.65a1.289,1.289,0,0,1,.082-2.575l.086,0A1.289,1.289,0,0,1,43.4,79.65Zm15.756-8.943-10.031-10h0l.113-.286a.548.548,0,0,0-.035-.473.472.472,0,0,0-.38-.241l-.746-.045h0l-.814-.048-.062.965a11.219,11.219,0,0,1-1.282,4.2,5.941,5.941,0,0,1-2.9,2.782,4.26,4.26,0,0,1-.756.1.884.884,0,0,1-.377-.069l-.381-.176a.672.672,0,0,1-.346-.383.738.738,0,0,1,0-.517l3.815-8.373.649-.427.261-.1h0l4.795-1.829a2.7,2.7,0,0,1,.938-.178h.027a2.694,2.694,0,0,1,.914.16l5.584,2.007,4.763,9.548Z"
                      transform="translate(-23.1 -50.262)"
                      fill={
                        location.pathname.startsWith("/contacts")
                          ? "#123A79"
                          : "#8C8C8C"
                      }
                    />
                    <path
                      id="Path_632"
                      data-name="Path 632"
                      d="M155.089,40.557l-3.77,1.88a2.371,2.371,0,0,0-1.063,3.179l4.936,9.9a2.371,2.371,0,0,0,3.178,1.063l3.769-1.881ZM158.361,54.7a.908.908,0,1,1,.909-.907A.908.908,0,0,1,158.361,54.7Z"
                      transform="translate(-113.603 -39.609)"
                      fill={
                        location.pathname.startsWith("/contacts")
                          ? "#123A79"
                          : "#8C8C8C"
                      }
                    />
                    <path
                      id="Path_633"
                      data-name="Path 633"
                      d="M0,49.576,3.447,52a2.369,2.369,0,0,0,3.3-.577L13.1,42.372a2.37,2.37,0,0,0-.576-3.3L9.081,36.65Zm2.973-.464a.908.908,0,1,1,.763,1.033A.908.908,0,0,1,2.973,49.112Z"
                      transform="translate(0 -36.65)"
                      fill={
                        location.pathname.startsWith("/contacts")
                          ? "#123A79"
                          : "#8C8C8C"
                      }
                    />
                  </g>
                </g>
              </svg> :
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="27" viewBox="0 0 24 24">
                <path 
                  d="M12 2a5 5 0 0 1 5 5v2a5 5 0 0 1-10 0V7a5 5 0 0 1 5-5zm-3 5v2a3 3 0 0 0 6 0V7a3 3 0 0 0-6 0zm3 10c-4.42 0-8 2.24-8 5v2h16v-2c0-2.76-3.58-5-8-5z" 
                  fill={
                    location.pathname.startsWith("/contacts")
                      ? "#123A79"
                      : "#8C8C8C"
                  }
                />
              </svg>}
            </div>
            <div>
              <Link to="/contacts">
                <span className={styles.fontTabMain} style={{ color: location.pathname.startsWith("/contacts") ? "#123A79" : "#8C8C8C" }}>
                {bos ? "Users" : "Contacts" }
                </span>
              </Link>
            </div>
          </div>
        </Menu.Item>

        {!bos && <Menu.Item
          key="2"
          style={(location.pathname.startsWith("/calendar") ?  highlightStyle : {})}
          className={styles.tabWidth}
        >
          <div className={styles.mainDiv}>
            <div className={styles.subDivMain}>
              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="31" viewBox="0 0 41 37.426">
                <path id="Calendar-Icon-987yghj" d="M19.513,26.664A9.743,9.743,0,1,1,29.274,36.4h-.028a9.692,9.692,0,0,1-9.734-9.735Zm2.584-.077a7.156,7.156,0,1,0,7.239-7.08h-.067A7.183,7.183,0,0,0,22.1,26.58ZM3.845,35.1A3.837,3.837,0,0,1,.215,32.427,4.173,4.173,0,0,1,0,31.083q.007-11.6,0-23.2A3.954,3.954,0,0,1,3.557,3.912c.251-.033.364.033.353.32-.022.622-.011,1.245,0,1.869A3.1,3.1,0,0,0,5.646,8.99a3.065,3.065,0,0,0,3.4-.226,3.09,3.09,0,0,0,1.36-2.62c0-.637.008-1.272,0-1.909,0-.232.038-.336.306-.334q1.645.022,3.291,0c.263,0,.318.088.313.328-.014.622-.008,1.245,0,1.869a3.109,3.109,0,0,0,1.736,2.889,3.067,3.067,0,0,0,3.386-.222A3.091,3.091,0,0,0,20.8,6.147c0-.637.013-1.274,0-1.909-.009-.276.088-.337.347-.335q1.623.018,3.249,0c.263,0,.32.083.314.326-.014.622-.008,1.246,0,1.869a3.112,3.112,0,0,0,1.736,2.889,3.067,3.067,0,0,0,3.4-.223,3.1,3.1,0,0,0,1.368-2.618c0-.637.013-1.272,0-1.908-.009-.274.08-.364.344-.328A3.955,3.955,0,0,1,35.1,7.887q.007,4.2,0,8.4v.357a13.143,13.143,0,0,0-2.017-.9.675.675,0,0,1-.594-.843c.047-.537,0-1.082.014-1.624,0-.209-.059-.306-.276-.277a1.54,1.54,0,0,1-.2,0Q17.565,13.005,3.1,13c-.394,0-.515.077-.513.5q.024,8.774,0,17.547A1.435,1.435,0,0,0,4.08,32.517c3.044-.018,6.089-.018,9.134-.017h5.57a.722.722,0,0,1,.743.382,12.379,12.379,0,0,0,1.715,2.15c-.011.093-.063.074-.1.074H11.768q-3.963.005-7.926-.009Zm22.023-4.831a.507.507,0,0,1,.025-.7c.62-.763,1.236-1.528,1.872-2.274a1.28,1.28,0,0,0,.335-.718c.093-1.044.163-2.089.255-3.132.063-.72.154-1.444.23-2.157.037-.358.278-.46.59-.479a.62.62,0,0,1,.727.429,5.657,5.657,0,0,1,.131,1.2c.131,1.05.179,2.113.263,3.171.049.561.119,1.12.181,1.681a1.216,1.216,0,0,1-.576,1.128c-.939.675-1.851,1.387-2.769,2.089a.926.926,0,0,1-.548.234C26.332,30.735,26.123,30.535,25.868,30.271ZM15.6,29.9H13.693A.622.622,0,0,1,13,29.2q-.008-1.257,0-2.513a.613.613,0,0,1,.672-.681q1.926-.011,3.851,0a.615.615,0,0,1,.674.681q.011,1.255,0,2.512a.622.622,0,0,1-.692.7H15.6Zm-9.7,0a.625.625,0,0,1-.7-.7c0-.836,0-1.676,0-2.512a.622.622,0,0,1,.709-.688q1.884-.007,3.769,0a.63.63,0,0,1,.72.717q.007,1.236,0,2.473c0,.481-.238.705-.729.709H5.9Zm7.772-5.2A.613.613,0,0,1,13,24.022q-.011-1.257,0-2.513a.622.622,0,0,1,.695-.7H17.5a.622.622,0,0,1,.692.7q.008,1.257,0,2.513a.613.613,0,0,1-.674.68H13.676Zm-7.8,0a.613.613,0,0,1-.674-.68c-.007-.838,0-1.676,0-2.513a.622.622,0,0,1,.693-.7H9.705a.624.624,0,0,1,.695.7q0,1.257,0,2.513a.613.613,0,0,1-.672.681H5.879Zm7.858-5.2c-.508,0-.731-.231-.734-.746V16.329a.63.63,0,0,1,.716-.72h3.77c.483,0,.71.235.712.725v2.473a.622.622,0,0,1-.7.7H13.736Zm-7.829,0a.622.622,0,0,1-.7-.692q-.008-1.257,0-2.513a.622.622,0,0,1,.709-.693h3.77a.632.632,0,0,1,.724.713q.007,1.237,0,2.473a.63.63,0,0,1-.725.712H5.9Zm14.9-3.2c0-.412.213-.689.579-.692,1.519-.013,3.039,0,4.572.033A11.87,11.87,0,0,0,20.8,18.993c0-.984,0-1.837,0-2.688Zm7.015-8.5A2,2,0,0,1,26,5.9q-.025-1.989,0-3.977a1.947,1.947,0,1,1,3.895.025c.009.65,0,1.3,0,2.1a13.807,13.807,0,0,1-.079,2.266,1.97,1.97,0,0,1-1.861,1.49.984.984,0,0,1-.138,0Zm-20.667,0A2,2,0,0,1,5.205,5.874c-.011-.663,0-1.325,0-2.142A14.66,14.66,0,0,1,5.283,1.5,1.939,1.939,0,0,1,7.318.015,1.981,1.981,0,0,1,9.1,1.9c.018,1.339.021,2.68,0,4.018A1.985,1.985,0,0,1,7.153,7.807ZM17.389,7.8a1.981,1.981,0,0,1-1.782-1.884q-.029-2.008,0-4.018a1.946,1.946,0,0,1,3.892.042c.011.657,0,1.325,0,2.146a14.784,14.784,0,0,1-.075,2.224,1.941,1.941,0,0,1-1.883,1.5c-.051,0-.1,0-.152-.008Z" transform="translate(0.5 0.526)" fill={location.pathname.startsWith("/calendar") ? "#123A79" : "#8C8C8C" } stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"/>
              </svg>
            </div>
            <div onClick={handleAgentClick}>
              <Link
                to={`/calendar/${today.getFullYear()}-${
                  today.getMonth() + 1
                }-${today.getDate()}`}
              >
                <span className={styles.fontTabMain} style={{ color: location.pathname.startsWith("/calendar") ? "#123A79" : "#8C8C8C" }}>
                  Calendar
                </span>
              </Link>
            </div>
          </div>
        </Menu.Item>}
        {!bos && <Menu.Item
          key="5"
          style={(location.pathname.startsWith("/tools") ?  highlightStyle : {})}
          className={styles.tabWidth}
        >
          <div className={styles.mainDiv}>
            <div className={styles.subDivMain}>
              <svg width="28" height="28" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
                <path fill={ location.pathname.startsWith("/tools") ? "#123A79" : "#8C8C8C" } d="M764.416 254.72a351.68 351.68 0 0186.336 149.184H960v192.064H850.752a351.68 351.68 0 01-86.336 149.312l54.72 94.72-166.272 96-54.592-94.72a352.64 352.64 0 01-172.48 0L371.136 936l-166.272-96 54.72-94.72a351.68 351.68 0 01-86.336-149.312H64v-192h109.248a351.68 351.68 0 0186.336-149.312L204.8 160l166.208-96h.192l54.656 94.592a352.64 352.64 0 01172.48 0L652.8 64h.128L819.2 160l-54.72 94.72zM704 499.968a192 192 0 10-384 0 192 192 0 00384 0z"/>
              </svg>
            </div>
            <div>
              <Link to="/tools">
                <span className={styles.fontTabMain} style={{ color: location.pathname.startsWith("/tools") ? "#123A79" : "#8C8C8C"}}>
                  Tools
                </span>
              </Link>
            </div>
          </div>
        </Menu.Item>}
      </Menu>
      <AppUpdate/>
      {location.pathname.includes("/login") || location.pathname.includes("/logout") || location.pathname.includes("/changePassword") ?  <div></div> : <div>
        <Help tabName={tabName}/>
      </div>}
    </div>
  );
}
export { SideBar };
